import { actions } from './surveys/actions'
import { getters } from './surveys/getters'
import { mutations } from './surveys/mutations'
import { surveyState as state } from './surveys/state'

import { categoryActions } from './surveyCategories/actions'
import { getters as categoryGetters } from './surveyCategories/getters'
import { mutations as categoryMutations } from './surveyCategories/mutations'
import { SurveyCategoryState } from './surveyCategories/state'

const Surveys = {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}
console.log("TCL:  ~ file: index.js ~ line 18 ~ Surveys", Surveys)

const SurveyCategories = {
	namespaced: true,
	state: SurveyCategoryState,
	getters: categoryGetters,
	mutations: categoryMutations,
	actions: categoryActions,
}

export { Surveys, SurveyCategories }
